export default __webpack_public_path__ + "static/media/57.904086a6.png";